"use client";
import {
  useVisuallyHidden
} from "./BG6HZDS7.js";
import {
  createComponent,
  createElement,
  createHook
} from "./3ORBWXWF.js";
import {
  __spreadProps,
  __spreadValues
} from "./4R3V3JGP.js";

// src/focus-trap/focus-trap.ts
var useFocusTrap = createHook((props) => {
  props = __spreadProps(__spreadValues({
    "data-focus-trap": "",
    tabIndex: 0,
    "aria-hidden": true
  }, props), {
    style: __spreadValues({
      // Prevents unintended scroll jumps.
      position: "fixed",
      top: 0,
      left: 0
    }, props.style)
  });
  props = useVisuallyHidden(props);
  return props;
});
var FocusTrap = createComponent((props) => {
  const htmlProps = useFocusTrap(props);
  return createElement("span", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  FocusTrap.displayName = "FocusTrap";
}

export {
  useFocusTrap,
  FocusTrap
};
